// extracted by mini-css-extract-plugin
export default {"wrapper":"ScaleSelection_wrapper__7y4lf","container":"ScaleSelection_container__rYT8W","option":"ScaleSelection_option__j6c6U"};